export const RANKING_GET_REQUEST = "RANKING_GET_REQUEST";
export const RANKING_SET = "RANKING_SET";
export const RANKING_USER_SET = "RANKING_USER_SET";
export const RANKING_USER_GET_REQUEST = "RANKING_USER_GET_REQUEST";
export const RANKING_UNSET = "RANKING_UNSET";
export const RANKING_USER_PAGE_CHANGE = "RANKING_USER_PAGE_CHANGE";
export const RANKING_USER_LOAD_SET = "RANKING_USER_LOAD_SET";
export const RANKING_USER_LOAD_REQUEST = "RANKING_USER_LOAD_REQUEST";
export const RANKING_USER_STOP_LOAD = "RANKING_USER_STOP_LOAD";

export const GET_CAMPAIGN_TEAM_RANKING_REQUESTING =
  "GET_CAMPAIGN_TEAM_RANKING_REQUESTING";
export const GET_CAMPAIGN_TEAM_RANKING_SUCCESS =
  "GET_CAMPAIGN_TEAM_RANKING_SUCCESS";
export const GET_CAMPAIGN_TEAM_RANKING_ERROR =
  "GET_CAMPAIGN_TEAM_RANKING_ERROR";

export const LOAD_CAMPAIGN_TEAM_RANKING_REQUESTING =
  "LOAD_CAMPAIGN_TEAM_RANKING_REQUESTING";
export const LOAD_CAMPAIGN_TEAM_RANKING_SUCCESS =
  "LOAD_CAMPAIGN_TEAM_RANKING_SUCCESS";
export const LOAD_CAMPAIGN_TEAM_RANKING_ERROR =
  "LOAD_CAMPAIGN_TEAM_RANKING_ERROR";
